import request from "@/utils/request";

// 获取申请材料信息
export function getApplicationMaterialsByApplicationId(applicationId) {
  return request({
    url: "/cloud/application/materials?applicationId=" + applicationId,
    method: "get"
  });
}

